import * as base from "./lib/baseActions";
import { UserInfo } from 'context/user';
import { RoleType } from "actions/roleActions";
import { AddOrEditUserErrors } from "pages/AddOrEditUser";

export interface addOrEditUserData {
  fullName?: string;
  email?: string;
  password?: string;
  roleId?: number;
  organizationId?: number;
};

// returned users are filtered by permissions as well on the backend
const getUsers = async (searchQuery?: string | undefined): Promise<base.DataWrapper<UserInfo[]>> => {
  try {
    let getUsersUrl = 'adminPanelUsers';
    if (searchQuery) {
      getUsersUrl += `?searchQuery=${searchQuery}`;
    }
    const usersResult = await base.get(getUsersUrl);
    return usersResult;
  } catch (err) {
    throw err;
  }
};

const getAdminById = async (id: string | number) => {
  try {
    const userResult = await base.get(`adminPanelUser/${id}`);
    return userResult;
  } catch (err) {
    throw err;
  }
};

const createAdminPanelUser = async (data: addOrEditUserData) : Promise<base.DataWrapper<UserInfo & RoleType>> => {
  const { fullName, email, roleId, organizationId } = data;

  try {
    const createAdminPanelUserResult = await base.post("adminPanelUser", { fullName, email, roleId, organizationId });
    return createAdminPanelUserResult;
  } catch (err) {
    if (err?.original?.response?.status === 400) {
      throw base.customizeError(err, AddOrEditUserErrors.UserAlreadyExistsError);
    } else {
      throw base.customizeError(err, AddOrEditUserErrors.GeneralAddError);
    }
  }
};

const updateAdminPanelUser = async (data: addOrEditUserData) : Promise<base.DataWrapper<UserInfo & RoleType>> => {
  const { fullName, email, password, roleId, organizationId } = data;

  try {
    const updateAdminPanelUserResult = await base.put("adminPanelUser", { fullName, email, password, roleId, organizationId });
    return updateAdminPanelUserResult;
  } catch (err) {
    throw base.customizeError(err, AddOrEditUserErrors.GeneralEditError);
  }

};

const deleteAdminPanelUser = async (id: string | number | undefined) => {
  try {
    const userResult = await base.del(`adminPanelUser/${id}`);
    return userResult;
  } catch (err) {
    throw err;
  }
}

export {
  getUsers,
  getAdminById,
  createAdminPanelUser,
  updateAdminPanelUser,
  deleteAdminPanelUser,
};
